import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";

import Button from "../../components/button";
import InputLabel, { InputLabelSelect } from "../../components/inputLabel";
import PageTitle from "../../components/pageTitle";
import espelhoProducaoActions from "../../redux/espelhoProducao/actions";
import { StoreState } from "../../redux/reduxTypes";
import { EspelhoProducaoState, UserSession } from "../../types/state.types";
import {
  AreaCooperado,
  AreaData,
  AreaInfo,
  AreaResumoTabela,
  ColunasDescricao,
  ContainerPagina,
  FormFiltros,
  LinhasTabela,
  TabelaConteudo,
} from "./styled";

import { getSessionConfig } from "../../utils/session-helper";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import IndicadorSemDados from "../../components/indicadorSemDados";
import { validarData, validarPeriodo } from "../../utils/functions-helper";
import routes from "../../routes/routes.path";

function EspelhoProducao() {
  const dispatch = useDispatch();
  const {
    filtros,
    filtrosBuscados,
    listaSetores,
    listaLotacoes,
    dadosEspelho,
    dadosEspelhoResumo,
    requisitado,
    loading,
  } = useSelector<StoreState, EspelhoProducaoState>(
    (state) => state.espelhoProducaoState
  );
  const userData = useSelector<StoreState, UserSession | undefined>(
    (state) => state.loginState.userData
  );
  const navigate = useNavigate();
  const [possuiNaoAutorizados, setpossuiNaoAutorizados] =
    useState<boolean>(false);
  const [cooperativaSessionData] = useState(getSessionConfig());

  const setFiltros = (value: {}) => {
    dispatch(
      espelhoProducaoActions.setFiltros({
        ...filtros,
        ...value,
      })
    );
  };

  const buscarLotacoes = useCallback(async () => {
    if (!validarData(filtros.dataInicio)) {
      return message.warning("Data inicial inválida");
    }
    if (!validarData(filtros.dataFim)) {
      return message.warning("Data final inválida");
    }
    if (!validarPeriodo(filtros.dataInicio, filtros.dataFim)) {
      return message.warning("Data final anterior à inicial");
    }
    await dispatch(
      espelhoProducaoActions.buscarLotacoes(filtros.dataInicio, filtros.dataFim)
    );
  }, [dispatch, filtros.dataFim, filtros.dataInicio]);

  const buscarSetores = useCallback(
    async (lotacaoId?: string) => {
      if (!validarData(filtros.dataInicio)) {
        return message.warning("Data inicial inválida");
      }
      if (!validarData(filtros.dataFim)) {
        return message.warning("Data final inválida");
      }
      if (!validarPeriodo(filtros.dataInicio, filtros.dataFim)) {
        return message.warning("Data final anterior à inicial");
      }
      if (lotacaoId) {
        await dispatch(
          espelhoProducaoActions.buscarSetores(
            filtros.dataInicio,
            filtros.dataFim,
            lotacaoId
          )
        );
      }
    },
    [dispatch, filtros.dataFim, filtros.dataInicio]
  );

  const pesquisarEspelho = useCallback(async () => {
    if (filtros.lotacaoId === undefined || filtros.lotacaoId === "0") {
      if (listaLotacoes.length === 0) {
        return message.warning("Nenhuma Lotação para o periodo informado");
      }
      return message.warning("Por favor selecione uma Lotação");
    }
    if (!validarData(filtros.dataInicio)) {
      return message.warning("Data inicial inválida");
    }
    if (!validarData(filtros.dataFim)) {
      return message.warning("Data final inválida");
    }
    if (!validarPeriodo(filtros.dataInicio, filtros.dataFim)) {
      return message.warning("Data final anterior à inicial");
    }
    await dispatch(
      espelhoProducaoActions.buscar(
        filtros.dataInicio,
        filtros.dataFim,
        filtros.lotacaoId,
        filtros.setorId ?? "0"
      )
    );
  }, [
    dispatch,
    filtros.dataFim,
    filtros.dataInicio,
    filtros.lotacaoId,
    filtros.setorId,
    listaLotacoes.length,
  ]);

  const irParaImpressao = useCallback(() => {
    navigate(routes.EspelhoProducaoImpressao);
  }, [navigate]);
  /* 
  const gerarPDF = useCallback(async () => {
    const tabelaER = document.getElementById("conteudoParaPdf");

    if (tabelaER === null) {
      return message.error('Erro ao gerar PDF');
    }
    downloadPDFMultiPagina(`Espelho_Producao_${getSession().userData?.CPF}`, tabelaER);
  }, []);
 */
  useEffect(() => {
    if (!requisitado) {
      dispatch(espelhoProducaoActions.inicializaEstado());
    }
  }, [dispatch, requisitado]);

  useEffect(() => {
    if (dadosEspelho) {
      setpossuiNaoAutorizados(
        !!dadosEspelho.find((espelho) => espelho.Autorizado !== 1)
      );
    }
  }, [dadosEspelho]);

  return (
    <ContainerPagina>
      <PageTitle titulo="Espelho de Produção" />

      {/* dadosEspelho && dadosEspelho.length > 0 ?
      <Button
        primary
        onClick={(e) => {
          e.preventDefault();
          irParaImpressao();
        }}

      >
        <PrinterOutlined style={{ marginRight: '10px' }} />
        Imprimir
      </Button>
    : <></> */}

      <FormFiltros>
        <div>
          <section>
            <InputLabel
              labelText="Início"
              labelId="incio"
              type="date"
              value={filtros.dataInicio}
              onChange={(value) => {
                setFiltros({
                  dataInicio: value,
                });
              }}
              onBlur={() => {
                buscarLotacoes();
              }}
              required
            />

            <InputLabel
              labelText="Fim"
              labelId="fim"
              type="date"
              value={filtros.dataFim}
              onChange={(value) => {
                setFiltros({
                  dataFim: value,
                });
              }}
              onBlur={() => {
                buscarLotacoes();
              }}
              required
            />
          </section>

          <section>
            <InputLabelSelect
              labelText="Lotação"
              labelId="lotacaoId"
              options={listaLotacoes.map((item) => {
                return { label: item.Nome, value: item.ID.toString() };
              })}
              value={filtros.lotacaoId}
              onChange={(value) => {
                setFiltros({
                  lotacaoId: value,
                });

                if (value !== "0" && !isNaN(parseInt(value))) {
                  buscarSetores(value);
                }
              }}
              required
            />

            <InputLabelSelect
              labelText="Setor"
              labelId="setorId"
              options={listaSetores.map((item) => {
                return { label: item.Nome, value: item.ID.toString() };
              })}
              value={filtros.setorId}
              onChange={(value) => {
                setFiltros({
                  setorId: value,
                });
              }}
            />
          </section>
        </div>

        <div className="botoes">
          <Button
            onClick={(event) => {
              event.preventDefault();
              pesquisarEspelho();
            }}
            style={{ marginRight: "15px" }}
            primary
          >
            Consultar
          </Button>

          {dadosEspelho && dadosEspelho.length > 0 ? (
            <Button
              primary
              onClick={(e) => {
                e.preventDefault();
                irParaImpressao();
              }}
            >
              <PrinterOutlined style={{ marginRight: "10px" }} />
              Imprimir
            </Button>
          ) : (
            <></>
          )}
          {/* <Button
          onClick={event => {
            event.preventDefault();
            gerarPDF();
          }}
          primary
        >
          <DownloadOutlined style={{ marginRight: '10px' }} />
          Gerar PDF
        </Button> */}
        </div>
      </FormFiltros>

      <div className="tabela">
        {!loading && dadosEspelho && dadosEspelho.length > 0 ? (
          <TabelaConteudo id="conteudoParaPdf">
            <tbody>
              <tr>
                <td>
                  <header>
                    <AreaData>
                      <tbody>
                        <tr>
                          <td>
                            {new Date().toLocaleDateString("pt-Br", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </AreaData>
                    <AreaInfo>
                      <tbody>
                        <tr>
                          <td>
                            <img
                              src={
                                "data:image/png;base64, " +
                                cooperativaSessionData.Logo
                              }
                              alt={`Logotipo - ${
                                cooperativaSessionData.Nome?.split(" ")[0]
                              }`}
                            />
                          </td>
                          <td className="containerInfos">
                            <span>
                              <strong>ESPELHO DE PRODUÇÃO</strong>
                              <br />
                              PERÍODO: &nbsp;
                              <strong>
                                {filtrosBuscados.dataInicio
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                                &nbsp;à&nbsp;
                                {filtrosBuscados.dataFim
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </strong>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </AreaInfo>
                    <AreaCooperado>
                      <tbody>
                        <tr>
                          <td>
                            Cooperado:{" "}
                            <strong>{userData ? userData.Nome : ""}</strong>
                          </td>
                          <td>
                            Matricula:{" "}
                            <strong>
                              {userData ? userData.Matricula : ""}
                            </strong>
                          </td>
                          <td>
                            Lotacao: <strong>{dadosEspelho[0].Lotacao}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </AreaCooperado>
                    {possuiNaoAutorizados ? (
                      <h3 className="aviso">
                        REGISTROS EM VERMELHO ESTÃO PENDENTES DE AUTORIZAÇÃO
                      </h3>
                    ) : (
                      <></>
                    )}
                  </header>

                  <ColunasDescricao>
                    <tbody>
                      <tr>
                        <td>Dia Semana</td>
                        <td>Função</td>
                        <td>Setor</td>
                        <td>Data Entrada</td>
                        <td>Data Saída</td>
                        <td>Tipo Plantão</td>
                        <td>Carga Horária</td>
                      </tr>
                    </tbody>
                  </ColunasDescricao>
                  <main>
                    <LinhasTabela>
                      <tbody>
                        {dadosEspelho ? (
                          dadosEspelho.map((espelho, i) => {
                            return (
                              <tr
                                key={i}
                                className={
                                  espelho.Autorizado ? "" : "naoAutorizado"
                                }
                              >
                                <td>{espelho.DiaSemana}</td>
                                <td>{espelho.Funcao}</td>
                                <td>{espelho.Setor}</td>
                                <td>
                                  {espelho.DescricaoData +
                                    " " +
                                    espelho.DescricaoHoraInicio}
                                </td>
                                <td>
                                  {espelho.HoraFim && espelho.HoraFim !== null
                                    ? espelho.HoraFim.split("T")[0]
                                        .split("-")
                                        .reverse()
                                        .join("/") +
                                      " " +
                                      espelho.DescricaoHoraFim
                                    : " -- "}
                                </td>
                                <td>{espelho.Turno}</td>
                                <td>
                                  {espelho.DescricaoHoras
                                    ? espelho.DescricaoHoras
                                    : " -- "}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </LinhasTabela>

                    <AreaResumoTabela>
                      {dadosEspelhoResumo ? (
                        <>
                          {
                            <tbody
                              dangerouslySetInnerHTML={{
                                __html: dadosEspelhoResumo,
                              }}
                            />
                          }
                        </>
                      ) : (
                        <></>
                      )}
                    </AreaResumoTabela>
                  </main>
                </td>
              </tr>
            </tbody>
          </TabelaConteudo>
        ) : (
          <IndicadorSemDados />
        )}
      </div>
    </ContainerPagina>
  );
}

export default EspelhoProducao;
